import React from 'react';

export default function Error(props) {
    if (!props.bind)
        return null;
    return (
        <p className='block font-medium text-sm text-gray-700 text-red-600 mt-2'>
            {props.text ?? props.bind}
        </p>
    );
}
